// src/features/assistant-connect/utils/access.ts
//
// Who is offered the connection, and which server they connect to. Both are pure so the app bar,
// the route guard, the page and the tests read the same rule.

import { CONNECTION_ENDPOINTS } from '../constants';
import type { InsightEnvironment } from './surface';

/** Effective roles (the impersonated one while impersonating) the assistant server accepts. */
export const ASSISTANT_ROLES = ['SuperAdmin', 'Admin', 'GroupAdmin', 'HotelAdmin', 'Viewer'] as const;

/**
 * The assistant server accepts a person whose Insight profile is superadmin, admin, chain director,
 * hotel director or viewer, and refuses every other profile before any tool runs. Offering the page
 * to a receptionist or to a documentation-only user would hand them a connection that fails at
 * sign-in, so they are not offered it. Widen it only together with the server and the realm clients.
 */
export const canConnectAssistant = (role: string | null | undefined): boolean =>
  !!role && (ASSISTANT_ROLES as readonly string[]).includes(role);

/**
 * The server for the Insight this browser is pointed at. Production connects to production; test, a
 * local build and an unrecognised address connect to test, the page warning in the last case.
 */
export const assistantServerUrl = (
  environment: InsightEnvironment,
  endpoints: { test: string; production: string } = CONNECTION_ENDPOINTS
): string => (environment === 'production' ? endpoints.production : endpoints.test);
